import React from "react";
import { Link } from "react-router-dom";

export default function RefundPolicy({ locale = "ko" }) {
  const isVi = locale === "vi";
  const tx = (ko, vi) => (isVi ? vi || ko : ko);

  return (
    <div className="mt-10 mb-10 rounded-lg border border-[#333] bg-[#1e1e1e] p-5 text-xs font-semibold leading-relaxed text-gray-400">
      <h3 className="text-gray-200 text-sm font-bold mb-3">
        {tx("환불 및 교환 안내", "Chính sách hoàn tiền")}
      </h3>
      <ul className="list-disc pl-5 space-y-1.5 opacity-80">
        <li>
          {tx(
            "결제 완료 후 선택한 서버에 즉시 적용되며, 즉시 공급에 동의하고 적용된 뒤에는 단순 변심 환불이 제한될 수 있습니다.",
            "Đây là sản phẩm kỹ thuật số, sau khi áp dụng cho server có thể bị hạn chế hoàn tiền."
          )}
        </li>
        <li>
          {tx(
            "결제 후 7일 이내이며 상품을 서버에 적용하지 않은 미사용 상태라면 전액 환불이 가능합니다.",
            "Trong vòng 7 ngày sau thanh toán, nếu sản phẩm chưa được sử dụng hoặc áp dụng cho server, có thể hoàn tiền toàn bộ."
          )}
        </li>
        <li>
          {tx(
            "상품이 표시 내용과 다르거나 정상 작동하지 않으면 공급일부터 3개월 이내 또는 그 사실을 안 날부터 30일 이내에 요청할 수 있습니다.",
            "Hoàn tiền do đổi ý chỉ áp dụng khi sản phẩm chưa sử dụng, thời gian xử lý có thể khác nhau tùy phương thức thanh toán."
          )}
        </li>
        <li>
          {tx(
            "환불이 확정되면 3영업일 이내에 환급 또는 결제 취소를 요청하며, 실제 반영 시점은 결제수단에 따라 달라질 수 있습니다.",
            "Nếu hiệu ứng không áp dụng đúng do lỗi sản phẩm hoặc hệ thống, vui lòng liên hệ hỗ trợ để được hoàn tiền hoặc đổi sản phẩm."
          )}
        </li>
      </ul>
      {!isVi && (
        <Link to="/ko/refund-policy" className="mt-4 inline-block text-[#aeb5ff] underline underline-offset-4 hover:text-white">
          청약철회 및 환불 정책 전문
        </Link>
      )}
    </div>
  );
}
